export default __webpack_public_path__ + "static/media/udemy.fd4add86.png";